import type { OptionKV } from "~styled/selector/Selector";

export enum ETipoSiniestro {
  Choque = "Choque",
  DestruccionTotal = "Destrucción Total",
  Cristales = "Cristales",
  Granizo = "Granizo",
  Cerradura = "Cerradura",
  RoboParcial = "Robo Parcial",
  RoboTotal = "Robo Total",
  IncendioTotal = "Incendio Total",
  IncendioParcial = "Incendio Parcial",
}

export const SELECCIONAR = "";
export const CHOQUE = ETipoSiniestro.Choque;
export const DESTRUCCION_TOTAL = ETipoSiniestro.DestruccionTotal;
export const CRISTALES = ETipoSiniestro.Cristales;
export const GRANIZO = ETipoSiniestro.Granizo;
export const CERRADURA = ETipoSiniestro.Cerradura;
export const ROBO_PARCIAL = ETipoSiniestro.RoboParcial;
export const ROBO_TOTAL = ETipoSiniestro.RoboTotal;
export const INCENDIO_TOTAL = ETipoSiniestro.IncendioTotal;
export const INCENDIO_PARCIAL = ETipoSiniestro.IncendioParcial;

const tipoSiniestroOptions: Record<
  ETipoSiniestro | typeof SELECCIONAR,
  string
> = {
  [SELECCIONAR]: "Seleccionar",
  [CHOQUE]: "Choque",
  [DESTRUCCION_TOTAL]: "Destrucción Total",
  [CRISTALES]: "Cristales",
  [GRANIZO]: "Granizo",
  [CERRADURA]: "Cerradura",
  [ROBO_PARCIAL]: "Robo Parcial",
  [ROBO_TOTAL]: "Robo Total",
  [INCENDIO_TOTAL]: "Incendio Total",
  [INCENDIO_PARCIAL]: "Incendio Parcial",
};

const tipoSiniestroFilter: OptionKV<ETipoSiniestro>[] = [
  { label: tipoSiniestroOptions[CHOQUE], value: CHOQUE },
  { label: tipoSiniestroOptions[DESTRUCCION_TOTAL], value: DESTRUCCION_TOTAL },
  { label: tipoSiniestroOptions[CRISTALES], value: CRISTALES },
  { label: tipoSiniestroOptions[GRANIZO], value: GRANIZO },
  { label: tipoSiniestroOptions[CERRADURA], value: CERRADURA },
  { label: tipoSiniestroOptions[ROBO_PARCIAL], value: ROBO_PARCIAL },
  { label: tipoSiniestroOptions[ROBO_TOTAL], value: ROBO_TOTAL },
  { label: tipoSiniestroOptions[INCENDIO_TOTAL], value: INCENDIO_TOTAL },
  { label: tipoSiniestroOptions[INCENDIO_PARCIAL], value: INCENDIO_PARCIAL },
];

export const TIPO_SINIESTRO_PLACEHOLDER = tipoSiniestroOptions[SELECCIONAR];
export { tipoSiniestroOptions, tipoSiniestroFilter };
